<script>
import MFASettings from "@/components/auth/MFASettings.vue";

export default {
  components: {
    MFASettings
  },
  name: "Settings"
};
</script>

<template>
  <MFASettings></MFASettings>
</template>

<style></style>
